<template>
  <div class="page-exbition-detail">

    <div class="detail-box">
      <div class="pic-box1">
        <img v-lazy="detail.spid" alt="">
      </div>
      <div class="exhibit">
        <h1 class="name ell">{{ detail.name }}</h1>
      </div>
    </div>

    <div class="detail-content">
      <div class="mb-40">
        <p v-html="detail.des"></p>
      </div>

      <div v-if="pics && pics.length>0">
        <h2>项目风采</h2>
        <div class="flex-box">
          <div class="item" v-for="(item,index) in pics" :key="index">
            <img v-if="item" :src="item" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  data() {
    return {
      detailId: this.$route.query.id,
      pics: [],
      detail: {}
    };
  },

  mounted() {
    this.getDetailData()
  },

  methods: {
    getDetailData() {
      this.$http
        .get('../singleMuseum/applet/volunteer/groupDetail', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.detail = res.result
            if (this.detail.pics) {
              let pics = this.detail.pics.split(';')
              pics.map(item => {
                if (item) {
                  this.pics.push(item)
                }
              })
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },

  },
};
</script>

<style lang="scss" scoped>
.qrcode {
  position: absolute;
  top: -80px;
  left: -80px;
  z-index: -99;
}
.detail-box {
  background: #f6f6f6;
  .pic-box1 {
    padding-top: 30px;
    width: 100%;
    height: 100%;
    background: #f6f6f6;
    text-align: center;
    img {
      width: 100%;
      height: 199%;
      object-fit: contain;
    }
  }

  .exhibit {
    margin: 40px auto 0;
    .name {
      padding: 0 36px;
      font-size: 48px;
      font-weight: 400;
      font-family: PF-regular;
      color: #000000;
      padding-bottom: 40px;
    }
  }
}

.detail-content {
  padding: 36px;
  // padding: 73px 724px 173px 163px;
  h2 {
    font-size: 38px;
    font-weight: 400;
    font-family: PF-regular;
    color: #000000;
    margin: 40px 0;
  }

  p {
    font-size: 32px;
    font-weight: 400;
    color: rgba($color: #000000, $alpha: 0.9);
    line-height: 48px;
  }

  /deep/img{
    max-width: 100%;
  }
}

.flex-box {
  width: 100%;
  flex-wrap: wrap;
  .item {
    width: 100%;
    background: #f6f6f6;
    margin-bottom: 30px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>